import { AWSCShortbreadCookieReader } from '@amzn/shortbread/dist/shortbread-cookie-reader';
import { COOKIES, DEFAULT_CONSENT } from '../constants/cookies';
import CookieDefinitions from '@amzn/shortbread/dist/definitions/cookie-definitions';
import { log } from '../utils/logger';

export default class CookieConsent {
  static cookieReader: AWSCShortbreadCookieReader;

  static setConsentChangeHandler(consentChangedHandler: (consent: CookieDefinitions.ConsentCookie) => void) {
    CookieConsent.cookieReader = AWSCShortbreadCookieReader({
      onConsentChanged: (consent: CookieDefinitions.ConsentCookie) => {
        log(`Cookie consent changed to ${JSON.stringify(consent)}`);
        consentChangedHandler(consent);
      },
    });
  }

  // Returns true if all passed-in cookie categories are allowed by the user
  static hasConsent(cookieNames: Array<string> | string): boolean {
    const names: Array<string> = Array.isArray(cookieNames) ? cookieNames : [cookieNames];

    // Use most current consent from common consent cookie
    const consent = CookieConsent.cookieReader.getConsentCookie() || DEFAULT_CONSENT;

    return names.every((name: string) => {
      const cookie = COOKIES[name as keyof typeof COOKIES];

      return consent[cookie?.cat as keyof typeof consent];
    });
  }
}
